import React, {PureComponent} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Loading from "../GenericLoading/loading";
import PropTypes from "prop-types";
import Form from "react-bootstrap/Form";

class SuperModal extends PureComponent {
	onOkPressed = (e) => {
		if(this.props.okLoading) return null;
		e.preventDefault();
		if (this.props.onOkPressed) this.props.onOkPressed();
	};

	onCancelPressed = () => {
		if (this.props.onCancelPressed) this.props.onCancelPressed();
		this.props.onCloseModal();
	};

	onCloseModal = () => {
		if (this.props.onCloseModal) this.props.onCloseModal();
	};

	render() {
		const {title, size} = this.props;
		return (

			<Modal
				show={true}
				onHide={this.onCloseModal}
				size={size}
				onClose={this.onCloseModal}
				aria-labelledby="contained-modal-title-vcenter"
				centered
			>
				<Form className='modal-content' onSubmit={this.onOkPressed}>
					<Modal.Header closeButton>
						<Modal.Title id="contained-modal-title-vcenter">
							{title}
						</Modal.Title>
					</Modal.Header>
					{this.renderModalBody()}
					<Modal.Footer>
						{this.renderPrimaryActionButton()}
						{this.renderSecondaryActionButton()}
					</Modal.Footer>
				</Form>
			</Modal>
		);
	}

	renderModalBody = () => {
		const {children} = this.props;

		if(children) {
			return(
				<Modal.Body>
					{children}
				</Modal.Body>
			)
		}
	};

	renderPrimaryActionButton = () => {
		const {okLoading, okButtonText, okButtonVariant} = this.props;
		return (
			<Button
				type='submit'
				variant={okButtonVariant}
			>
				{okLoading ? <Loading size={"small-spinner"} color={"white"}/> : okButtonText}
			</Button>
		)
	};

	renderSecondaryActionButton = () => {
		const {cancelLoading, cancelButtonText, cancelButtonVariant} = this.props;
		return (
			<Button
				variant={cancelButtonVariant}
				onClick={this.onCancelPressed}
			>
				{cancelLoading ? <Loading size={"small-spinner"} color={"white"}/> : cancelButtonText}
			</Button>
		)
	};


}

SuperModal.propTypes = {
	title: PropTypes.string,
	size: PropTypes.oneOf([
		"sm",
		"lg",
		"xl"
	]),
	onOkPressed: PropTypes.func.isRequired,
	okButtonText: PropTypes.string,
	okButtonVariant: PropTypes.oneOf([
		'primary',
		'secondary',
		'success',
		'warning',
		'danger',
		'info',
		'light',
		'dark',
		'link'
	]),
	okLoading: PropTypes.bool,
	onCancelPressed: PropTypes.func,
	cancelButtonText: PropTypes.string,
	cancelButtonVariant: PropTypes.oneOf([
		'primary',
		'secondary',
		'success',
		'warning',
		'danger',
		'info',
		'light',
		'dark',
		'link'
	]),
	cancelLoading: PropTypes.bool,
	onCloseModal: PropTypes.func.isRequired,
};

SuperModal.defaultProps = {
	title: 'Modal',
	size: 'sm',
	onOkPressed: null,
	okButtonText: 'Ok',
	okButtonVariant: 'success',
	okLoading: false,
	onCancelPressed: null,
	cancelButtonText: 'Cancel',
	cancelButtonVariant: 'secondary',
	cancelLoading: false,
	onCloseModal: null,
};


export default SuperModal;
